import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  userInfo: "",
  expiresAt: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.token = action.payload.token ? action.payload.token : state.token;
      state.userInfo = action.payload.userInfo
        ? action.payload.userInfo
        : state.userInfo;
      state.expiresAt = action.payload.expiresAt
        ? action.payload.expiresAt
        : state.expiresAt;
    },
    clearAuth: (state) => {
      state.token = "";
      state.userInfo = "";
      state.expiresAt = "";
    },
  },
});

export const { setAuth, clearAuth } = authSlice.actions;
export default authSlice.reducer;
